export const hover = () => `
  transition: all 300ms cubic-bezier(0.50, -0.3, 0.50, 1.5);
`
